import React, { Component } from 'react';
import CheckboxComponent from './CheckboxComponent';
import ColorPicker from './ColorPicker';
import PixelSelector from './PixelSelector';
class LineSettingsComponent extends Component {
	render() {
		if (!this.props?.name) {
			return <>Loading</>;
		}
		return (
			<tr>
				<td>
					{this.props.text}:
				</td>

				<td>
					<CheckboxComponent
						checked={this.props.values.show}
						name={this.props.name + "_show"}
						callback={(n, v) => this.props.callback(n, v)}
					/>
				</td>
				<td>
					<ColorPicker
						color={this.props.values.color}
						callback={(color) => this.props.callback(this.props.name + "_color", color)}
					/>
				</td>
				<td>
					<PixelSelector
						pixels={this.props.values.pixels}
						callback={(pixels) => this.props.callback(this.props.name + "_pixels", pixels)}
					/>
				</td>
			</tr>
		);
	}
}

export default LineSettingsComponent;